module.exports = __webpack_public_path__ + "img/counter_men.2a4e99f3.svg";